import dayjs from 'dayjs';
import { IProductOrder } from 'app/shared/model/product-order.model';
import { IProductOffering } from 'app/shared/model/product-offering.model';
import { IEan } from 'app/shared/model/ean.model';
import { ProductStatus } from 'app/shared/model/enumerations/product-status.model';
import { FeedType } from 'app/shared/model/enumerations/feed-type.model';
import { FeedInType } from 'app/shared/model/enumerations/feed-in-type.model';
import { ProductType } from 'app/shared/model/enumerations/product-type.model';

export interface IProduct {
  id?: number;
  productStatus?: keyof typeof ProductStatus | null;
  feedType?: keyof typeof FeedType | null;
  feedInType?: keyof typeof FeedInType | null;
  productType?: keyof typeof ProductType | null;
  initialEstimatedYearlyQuantity?: number | null;
  retrievedYearlyQuantityReading?: number | null;
  initialFixedAnnualPrice?: number | null;
  activeDate?: dayjs.Dayjs | null;
  inactiveDate?: dayjs.Dayjs | null;
  usage?: number | null;
  desireStartDate?: dayjs.Dayjs | null;
  desireEndDate?: dayjs.Dayjs | null;
  productOrder?: IProductOrder | null;
  productOffering?: IProductOffering | null;
  ean?: IEan | null;
}

export const defaultValue: Readonly<IProduct> = {};
